import { DSPhone } from '@demandstar/components/phone';

export const commonPhone = {
  tollFree: '8662731863',
} as const;

export const TollFreeNumber = <DSPhone>{commonPhone.tollFree}</DSPhone>;
